module.exports = __webpack_public_path__ + "static/media/c02-01-2.e72e16f7.png";